import React from "react"
import AlignedBlock from "../components/aligned-block"
import VideoEmbedBlock from "./video-embed-block"

const AlignedVideoEmbedBlock = props => (
  <AlignedBlock align={props.data.align}>
    <VideoEmbedBlock {...props} />
  </AlignedBlock>
)

export default AlignedVideoEmbedBlock
